import React from 'react';
import { useWindowDimensions } from 'react-native';
import {
  BREAKPOINTS,
  Button,
  IllusFoodOnItsWay,
  useBreakpointHelpers,
} from '@sweetgreen/garnish';

import { useLocalizationContext } from '@order/Localization';

import { FeaturedChannel } from '../FeaturedChannels.components';

export const SecondaryChannel = (props: SecondaryChannelProps) => {
  const { checkMinWidth } = useBreakpointHelpers();
  const { titleCopy, buttonCopy } = useSecondaryCopy();

  return (
    <FeaturedChannel testID="featured-channel.secondary.card">
      <FeaturedChannel.Illustration source={IllusFoodOnItsWay} />
      <FeaturedChannel.TextContainer>
        <FeaturedChannel.Title>{titleCopy}</FeaturedChannel.Title>
      </FeaturedChannel.TextContainer>
      <FeaturedChannel.ButtonWrapper>
        <Button
          testID="featured-channel.secondary.button"
          palette="secondary"
          onPress={props.onSeeMoreLocations}
          size={checkMinWidth.desktop ? 'large' : 'medium'}
        >
          {buttonCopy}
        </Button>
      </FeaturedChannel.ButtonWrapper>
    </FeaturedChannel>
  );
};

// ────────────────── Hooks ──────────────────

const useSecondaryCopy = () => {
  const { t } = useLocalizationContext();
  const { width } = useWindowDimensions();

  return {
    titleCopy: t('featured-channel.secondary.title'),
    buttonCopy:
      width > BREAKPOINTS[1].MAX + BREAKPOINTS[1].MARGIN
        ? t('featured-channel.secondary.button-large')
        : t('featured-channel.secondary.button-medium'),
  };
};

// ────────────────── Types ──────────────────

type SecondaryChannelProps = {
  readonly onSeeMoreLocations: () => void;
};
